import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import PressReleasePage, { Props } from "../components/press/PressReleasePage";
import PageProps from "../lib/models/pageProps";

export default function PressReleaseP(props: Props) {
  return <PressReleasePage {...props} />;
}

PressReleaseP.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<Props> => {
  const { slug } = query;
  const content = await api.loadPressReleaseBySlug(slug as string).catch(() => {
    throw new PageNotFoundError();
  });

  let _pageImages;
  try {
    _pageImages = PressReleasePage.getImages(content);
  } catch (error) {
    console.error(error);
  }

  return { ...content, _pageImages };
};
